actions:
  yes: "Ja"
  no: "Nee"
  cancel: "Annuleren"
  continue: "Doorgaan"
  view: "Bekijken"
  restore: "Herstellen"
  logout: "Uitloggen"
  login: "Inloggen"
  refreshPage: "Pagina vernieuwen"
  save: "Opslaan"
  add: "Toevoegen"
  edit: "Aanpassen"
  delete: "Verwijderen"
  copy: "Kopiëren"

messages:
  loading: "Laden..."
  areYouSure: "Weet je het zeker?"
  actionCantBeReverted: "Deze actie kan niet ongedaan worden gemaakt."
  copied: "Gekopieerd naar klembord."

errors:
  updateAvailable: "Er is een nieuwe versie beschikbaar."
  generic: "Er is iets misgegaan. Probeer het opnieuw."

validation:
  required: "Dit veld is verplicht."
  minValue: "Moet minimaal {min} zijn."
  email: "Vul een geldig e-mailadres in."
